export default "__VITE_ASSET__654c6276__"